import React, { useEffect, useState } from 'react';
import NftCard from '../Card/NftCard';
import { collection, getDocs, query, where } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { skeleTonJson } from '../common/jsonDumb';

export default function MintedTab(props) {
  const [loadingNfts, setloadingNfts] = useState(true);
  const [nftDataArr, setnftDataArr] = useState([]);

  useEffect(() => {
    if (props.collectorId) {
      getSellerMintedNfts();
    }
  }, [props.collectorId]);

  const getSellerMintedNfts = async () => {
    setloadingNfts(true);

    let nftRef = query(
      collection(firebaseFireStore, 'musicartNfts'),
      where('adminState', '==', 'ACCEPT'),
      where('activeInMarketPlace', '==', true),
      where('issuerID', '==', props.collectorId),
    );

    let nftData = await getDocs(nftRef);
    let dataArr = [];

    nftData.forEach((doc) => {
      let cObj = doc.data();

      if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
        let startingPrice = 0;
        Object.values(cObj.multipleNftDetails)
          .filter((x) => x.activeInMarketPlace)
          .map((ele, index) => {
            if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
              if (
                ele.nftSaleType &&
                ele.nftSaleType !== 'Auctioning' &&
                ele.price &&
                (!startingPrice ||
                  (startingPrice && Number(ele.price) < startingPrice))
              ) {
                startingPrice = Number(ele.price);
              } else if (
                ele.nftSaleType &&
                ele.nftSaleType === 'Auctioning' &&
                ele.auctionEndTime &&
                ele.minBiddingPrice &&
                (!startingPrice ||
                  (startingPrice &&
                    Number(ele.minBiddingPrice) < startingPrice))
              ) {
                // console.log("rrun");
                startingPrice = Number(ele.minBiddingPrice);
              }
            }
          });
        if (startingPrice) {
          dataArr.push({ ...cObj, startingPrice: startingPrice });
        }
      } else {
        if (
          (cObj.nftSaleType &&
            cObj.nftSaleType === 'Auctioning' &&
            cObj.auctionEndTime &&
            cObj.minBiddingPrice) ||
          (cObj.nftSaleType !== 'Auctioning' && cObj.price)
        ) {
          dataArr.push(cObj);
        }
      }
    });

    dataArr.sort((a, b) => Number(b.likes) - Number(a.likes));

    setnftDataArr([...dataArr]);
    console.log('data', dataArr);
    setloadingNfts(false);
  };

  return (
    <div className="seller__tab_pane" role="tabpanel">
      <div className="seller__tab_content">
        <div className="row row--grid" key="1">
          {loadingNfts
            ? skeleTonJson.slice(0, 6).map((ele, index) => (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens-artist"
                  key={'nft-' + index}
                >
                  <NftCard
                    // nftDataArr={nftDataArr}
                    ele={ele}
                    index={index}
                    // setNFTDataArr={setNFTDataArr}
                  />
                </div>
              ))
            : nftDataArr.map((ele, index) => {
                if (
                  (ele.nftSaleType &&
                    ele.nftSaleType === 'Auctioning' &&
                    ele.auctionEndTime) ||
                  ele.nftSaleType !== 'Auctioning'
                ) {
                  return (
                    <div
                      style={{ display: 'block' }}
                      className="turning-screens-artist"
                      key={'nft-' + index}
                    >
                      <NftCard
                        nftDataArr={nftDataArr}
                        ele={ele}
                        index={index}
                        nftDataArr={nftDataArr}
                        setnftDataArr={setnftDataArr}
                        category={'minted_tab_nfts'}
                      />
                    </div>
                  );
                }
              })}

          {!loadingNfts && nftDataArr.length === 0 && (
            <div className="text-center w-full text-blueGray-500">
              <p className="text-center mt-10">0 NFTs found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
